// extracted by mini-css-extract-plugin
module.exports = {"show-preset":"ShowPreset_show-preset__1zZiC"};